$('.slider').slick({
  autoplay: true,//自動的に動き出すか。初期値はfalse。
  infinite: true,//スライドをループさせるかどうか。初期値はtrue。
  slidesToShow: 5,//スライドを画面に5枚見せる
  slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
  prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
  nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
  dots:false,//下部ドットナビゲーションの表示
  responsive: [
    {
      breakpoint: 769,//モニターの横幅が769px以下の見せ方
      settings: {
        slidesToShow: 2,//スライドを画面に2枚見せる
        slidesToScroll: 2,//1回のスクロールで2枚の写真を移動して見せる
      }
    },
    // {
    //   breakpoint: 426,//モニターの横幅が426px以下の見せ方
    //   settings: {
    //     slidesToShow: 1,//スライドを画面に1枚見せる
    //     slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
    //   }
    // }
  ]
});

$('.slider-list').slick({
  autoplay: true,//自動的に動き出すか。初期値はfalse。
  infinite: true,//スライドをループさせるかどうか。初期値はtrue。
  slidesToShow: 4,//スライドを画面に3枚見せる
  slidesToScroll: 1,//1回のスクロールで3枚の写真を移動して見せる
  prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
  nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
  dots: false,//下部ドットナビゲーションの表示
  responsive: [
    {
      breakpoint: 769,//モニターの横幅が769px以下の見せ方
      settings: {
        slidesToShow: 2,//スライドを画面に2枚見せる
        slidesToScroll: 2,//1回のスクロールで2枚の写真を移動して見せる
      }
    },
    {
      breakpoint: 426,//モニターの横幅が426px以下の見せ方
      settings: {
        slidesToShow: 1,//スライドを画面に1枚見せる
        slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
      }
    }
  ]
});
$('.slider-review').slick({
  autoplay: true,//自動的に動き出すか。初期値はfalse。
  infinite: true,//スライドをループさせるかどうか。初期値はtrue。
  slidesToShow: 4,//スライドを画面に3枚見せる
  slidesToScroll: 1,//1回のスクロールで3枚の写真を移動して見せる
  prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
  nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
  dots: false,//下部ドットナビゲーションの表示
   centerMode:true,        //追記
    centerPadding:"10%",    //追記
  responsive: [
    {
      breakpoint: 1600,//モニターの横幅が1600px以下の見せ方
      settings: {
        slidesToShow: 3,//スライドを画面に2枚見せる
        slidesToScroll: 1,//1回のスクロールで2枚の写真を移動して見せる
      }
    },
    {
      breakpoint: 1100,//モニターの横幅が1100px以下の見せ方
      settings: {
        slidesToShow: 2,//スライドを画面に2枚見せる
        slidesToScroll: 1,//1回のスクロールで2枚の写真を移動して見せる
      }
    },
    {
      breakpoint: 650,//モニターの横幅が650px以下の見せ方
      settings: {
        slidesToShow: 1,//スライドを画面に1枚見せる
        slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
      }
    }
  ]
});
// lazyload画像を強制読み込みする共通関数
function forceLoadImages($el) {
  $el.find('img[data-src]').each(function() {
    var dataSrc = $(this).attr('data-src');
    if (dataSrc) {
      $(this).attr('src', dataSrc.replace('{width}', '540'));
      $(this).removeAttr('data-src');
      $(this).addClass('lazyloaded').removeClass('lazyload');
    }
  });
}

// スライダー共通設定
var sliderConfig = {
  autoplay: false,
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: '<div class="slick-prev"></div>',
  nextArrow: '<div class="slick-next"></div>',
  dots: false,
  responsive: [
    { breakpoint: 769, settings: { slidesToShow: 2, slidesToScroll: 1 } }
  ]
};

// おすすめ商品スライダー（Ajax読み込み後に初期化）
document.addEventListener('recommendations:loaded', function() {
  var $slider = $('.slider-recommendations');
  forceLoadImages($slider);
  $slider.slick(sliderConfig);
});

// 最近見た商品スライダー（DOM変更検知で初期化）
var recentEl = document.querySelector('.slider-recently-viewed');
if (recentEl) {
  var observer = new MutationObserver(function(mutations, obs) {
    var $slider = $(recentEl);
    if ($slider.children().length > 0) {
      obs.disconnect();
      forceLoadImages($slider);
      $slider.slick(sliderConfig);
      // セクション全体を表示
      $(recentEl).closest('[data-section-type="recently-viewed"]').show();
    }
  });
  observer.observe(recentEl, { childList: true });
}

$('.hero-slider').slick({
  autoplay: true,//自動的に動き出すか。初期値はfalse。
  infinite: true,//スライドをループさせるかどうか。初期値はtrue。
  slidesToShow: 1,//スライドを画面に3枚見せる
  slidesToScroll: 1,//1回のスクロールで3枚の写真を移動して見せる
  prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
  nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
  dots: false,//下部ドットナビゲーションの表示
   centerMode:true,        //追記
    centerPadding:"20%",    //追記
  responsive: [
   
    {
      breakpoint: 526,//モニターの横幅が526px以下の見せ方
      settings: {
        centerMode:false,        //追記
         centerPadding:"0px",    //追記
      }
    }
  ]
});